import { useAppContext } from '@contexts/app';
import { initialState } from '@contexts/app/constants';
import { usePanel } from '@hooks/usePanel';
import { localStore } from '@utils/localStore';
import { endSession } from '@utils/session';
import { useEffect } from 'react';

export const useImpersonateAuth = () => {
  const { isLogged, setData } = useAppContext();
  const { panel } = usePanel();

  const impersonate = localStore.getItem('app-impersonate');
  const startImpersonate = localStore.getItem('app-start-impersonate');
  const exiting = localStore.getItem('app-impersonate-exiting');

  useEffect(() => {
    if (!panel || !exiting) return;
    endSession('impersonationEnded', ['app-user', 'app-impersonate-exiting']);
    setData((prev) => ({ ...initialState, admin: prev.admin }));
  }, [panel, exiting, setData]);

  useEffect(() => {
    if (!panel || !impersonate || startImpersonate) return;
    localStore.removeItem('app-impersonate');
    if (!isLogged) return;
    endSession('impersonationEnded', ['app-user']);
    setData((prev) => ({ ...initialState, admin: prev.admin }));
  }, [isLogged, panel, impersonate, startImpersonate, setData]);
};
